import React from 'react';
import TemplateList from './ListTemplate';

export default function SectionFeatured({ data, settings = {}, embedded }) {
  const limit = settings.limit || undefined;
  const list = (data.featured || []).slice(0, limit);
  if (!list.length) return null;
  const inner = (
    <TemplateList kind="product" items={list} settings={{ sectionTitle: settings.sectionTitle || settings.title || 'پیشنهادات ویژه', ...settings }} />
  );
  if (embedded) return <div style={{ width: '100%' }}>{inner}</div>;
  return (
    <section className="container" style={{ padding: 'clamp(48px, 8vw, 88px) 20px' }}>
      {inner}
    </section>
  );
}
